// 文件上传类

class FileStore {
  constructor() {
    this.filename = ""
    this.size = 0
    this.mimetype = null
    this.stor_loc = ""
    this.url = ""
  }

  static async upload(file, parent_dir = null) {
    const url = process.env.VUE_APP_API_URL + "files/upload"
    let data = new FormData()
    if (parent_dir) {
      data.append("parent_dir", parent_dir)
    }

    data.append("file", file, file.name)

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
    const res = await axios.post(url, data, config)
    return res.data.file_store
  }
}

class FileUtils {
  static dataURLtoFile(dataurl, filename) {
    // 将base64编码的字符串转换为文件对象
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  }

  static createDownloadAction(
    downloadlink,
    filename = "文件下载",
    mimetype = "application/octet-stream"
  ) {
    const link = document.createElement("a")
    link.href = downloadlink
    link.setAttribute("download", filename)
    link.setAttribute("type", mimetype)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export { FileStore, FileUtils }
